import Text from 'components/Text/Text';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../dishFullInfoState/dishFullInfoContext';
import React, { useContext } from 'react';
import AdditionallySection from './components/AdditionallySection/AdditionallySection';
import CategorySubCategorySection from './components/CategorySubCategorySection/CategorySubCategorySection';
import { IsProtectedFromSync } from './components/IsProtectedFromSync';
import { TaxPercent } from './components/TaxPercent';
import { HasOpenPrice } from './components/HasOpenPrice';
import { OpenPrice } from './components/OpenPrice';
import { OpenPriceMaxThreshold } from './components/OpenPriceMaxThreshold';
import { IsFiscalized } from './components/IsFiscalized';
import MainInfoSection from './components/MainInfoSection/MainInfoSection';
import ComboModifierField from './components/ComboModifierField';
import ModifiersSection from './components/ModifiersSection/ModifiersSection';
import ExternalIdField from './components/ExternalIdField';
import IsDisabledField from './components/IsDisabledField';
import RestaurantsForComments from './components/RestaurantsForComments/RestaurantsForComments';
import TranslationsField from './components/TranslationsField';
import style from './MainInfoTab.module.scss';

const MainInfoTab: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container} data-test="MainInfoTab">
			<div className={style.mainInfoGroup}>
				<Text
					className={style.groupHeading}
					translationNameSpace="form"
					translationKey="mainInfoHeading"
					theme="secondaryFaded"
					size="xxl"
					weight="bold"
				/>
				<div className={style.groupSections}>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="infoHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<MainInfoSection />
					</div>
					{!dishForFullInfo?.isCombo && (
						<div className={style.fieldsWrapper}>
							<Text
								translationNameSpace="form"
								translationKey="comboModifierHeading"
								theme="secondary"
								size="l"
								weight="bold"
							/>
							<ComboModifierField />
						</div>
					)}
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="categoryAndSubcategoryHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<CategorySubCategorySection />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="taxHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<IsProtectedFromSync />
						{dishForFullInfo?.isTaxPercentProtectedFromSync && <TaxPercent />}
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="openPriceHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<HasOpenPrice />
						{dishForFullInfo?.hasOpenPrice && <OpenPrice />}
						{dishForFullInfo?.hasOpenPrice && <OpenPriceMaxThreshold />}
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="feeFiscalisationHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<IsFiscalized />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="externalIdHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<ExternalIdField />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="additionallyHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<AdditionallySection />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="inStopHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<IsDisabledField />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="commentsHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<RestaurantsForComments />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="translationsHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<TranslationsField />
					</div>
				</div>
			</div>
			<div className={style.extraOptionsGroup}>
				<Text
					className={style.groupHeading}
					translationNameSpace="form"
					translationKey="extraOptionsHeading"
					theme="secondaryFaded"
					size="xxl"
					weight="bold"
				/>
				<div className={style.groupSections}>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="modifiersHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<ModifiersSection />
					</div>
				</div>
			</div>
		</div>
	);
};

export default MainInfoTab;
